import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'


import jonathanMifsudPhoto from '../../assets/images/team/jonathan-mifsud.jpg';
import jeremyMifsudPhoto from '../../assets/images/team/jeremy-mifsud.jpg';
import davidSeisunPhoto from '../../assets/images/team/david-seisun.jpg';

const testimonials = [
  {
    name: "Gianmarco Santirocco",
    // logo: davidSeisunPhoto,
    organisation: "Deaf Association Malta",
    role: "Accountant",
    quote: "I find Buddy really straight forward and user friendly, more than all the other Maltese payroll software that I used, the information is well classified and of fast access."
  },
  {
    name: "Daniela Calleja",
    // logo: davidSeisunPhoto,
    organisation: "Actaco Financial",
    role: "Admin Assistant",
    quote: "Buddy is very straightforward to use and takes care of all the headaches that payroll brings along with it. More than that, the customer service is the best I have ever come across...their online assistance is impeccable; they are quick to answer any question you might have, guide you and never make you feel like you are asking too many questions. Their detailed explanations prove that they definitely know what they're doing! I would recommend Buddy to anyone who would like a simple, stress-free approach to managing payroll."
  },
  {
    name: "Daniela Calleja",
    // logo: davidSeisunPhoto,
    organisation: "Actaco Financial",
    role: "Admin Assistant",
    quote: "It has created confidence that the payroll is done correctly."
  },
  {
    name: "David Vallee",
    // logo: davidSeisunPhoto,
    organisation: "Insurem",
    role: "CEO",
    quote: "Buddy is easy to use and straight to the point. I lose no time nor energy to look out for I want."
  },
  {
    name: "Renald Dalli",
    // logo: davidSeisunPhoto,
    // organisation: "Actaco Financial",
    role: "Accountant",
    quote: `I have been using Buddy for the last year and a half. I was skeptical at first due to the low pricing but today I can say that I am happy with BuddyHR.

          BuddyHR has all what I require, easy to setup, multi company (and easy to switch between them), regular updates, web based and most importantly, a great customer support.
          I am always amazed at how fast they reply and solve the issues I forward them. Really friendly and always helpful.

          I would recommend BuddyHR to anyone from companies to freelancers.

          Keep it up!`
  },
  {
    name: "Eric Tenin",
    // logo: davidSeisunPhoto,
    organisation: "Inspirapps",
    role: "Entrepreneur",
    quote: `Great software at a very affordable price. But more than that really amazing and exceptional customer service. Highly recommended.`
  },
  {
    name: "Angele Debono",
    // logo: davidSeisunPhoto,
    organisation: "Safeye Malta",
    role: "PA to the Director",
    quote: `Buddy has simplified our payroll activities, it is very intuitive and easy to use.`
  },,
  {
    name: "Christine Camilleri",
    // logo: davidSeisunPhoto,
    organisation: "Circular Economy Malta",
    role: "Manager",
    quote: `Information can be accessed easily, saves time and money, excellent customer service that handle queries and concerns instantly.`
  },
]


function Testimonials({

}) {

  const [testimonialsToUse, setTestimonials] = useState(() => {
    const shuffled = testimonials.sort(() => 0.5 - Math.random());
    let selected = shuffled.slice(0, 2);
    return selected
  });


  return (

    <section id="testimonials" className="bg-orange-500">
      <div className="max-w-screen-xl mx-auto md:grid md:grid-cols-2 md:px-6 lg:px-8">
        <div className="py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 md:border-r md:border-orange-600 lg:pr-16">
          <div className="md:flex-shrink-0">
            {testimonialsToUse[0].logo && <img src={testimonialsToUse[0].logo}/>}
          </div>
          <blockquote className="mt-8 md:flex-grow md:flex md:flex-col">
            <div className="relative text-lg leading-7 font-medium text-white md:flex-grow">
              <svg className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-orange-600" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="relative">
                {testimonialsToUse[0].quote}
              </p>
            </div>
            <footer className="mt-8">
              <div className="flex">
                {
                  testimonialsToUse[0].photo && 
                    <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white">
                      <img className="h-12 w-12 rounded-full" src={testimonialsToUse[1].photo} alt=""/>
                    </div>
                }
                <div className="ml-4">
                  <div className="text-base leading-6 font-medium text-white">{testimonialsToUse[0].name}</div>
                  <div className="text-base leading-6 font-medium text-orange-200">{testimonialsToUse[0].role}{testimonialsToUse[0].organisation && ","} {testimonialsToUse[0].organisation}</div>
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
        <div className="py-12 px-4 border-t-2 border-orange-600 sm:px-6 md:py-16 md:pr-0 md:pl-10 md:border-t-0 md:border-l lg:pl-16">
          <div className="md:flex-shrink-0">
            {testimonialsToUse[1].logo}
          </div>
          <blockquote className="mt-8 md:flex-grow md:flex md:flex-col">
            <div className="relative text-lg leading-7 font-medium text-white md:flex-grow">
              <svg className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-orange-600" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="relative">
                {testimonialsToUse[1].quote}
              </p>
            </div>
            <footer className="mt-8">
              <div className="flex">
                {
                  testimonialsToUse[1].photo && 
                    <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white">
                      <img className="h-12 w-12 rounded-full" src={testimonialsToUse[1].photo} alt=""/>
                    </div>
                }
                
                <div className="ml-4">
                  <div className="text-base leading-6 font-medium text-white">{testimonialsToUse[1].name}</div>
                  <div className="text-base leading-6 font-medium text-orange-200">{testimonialsToUse[1].role}{testimonialsToUse[1].organisation && ","} {testimonialsToUse[1].organisation}</div>
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>


    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Testimonials) 
